<template>
  <div class="log">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.id"/>
          <div class="behavior">
            <div
              class="operation"
              v-if="operation">
              <el-select
                placeholder="操作类型"
                v-model="searchData.edit_key"
                size="small"
                @change="fetchData"
                filterable>
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item"
                  :value="index"/>
              </el-select>
            </div>
            <jm-tableList
              url="/index/log/action"
              :refresh.sync="refresh"
              :row-class-name="setRowClass"
              :search-data="searchData">
              <el-table-column
                slot="firstColumn"
                type="expand">
                <template slot-scope="props">
                  <el-form
                    label-position="left"
                    class="behavior-expand">
                    <el-col
                      v-for="i in props.row.info"
                      :key="i.value"
                      :sm="24"
                      :md="(i.column ? (i.column > 3 ? 3 : i.column) : 1) * 8"
                      :lg="(i.column ? i.column : 1) * 6">
                      <el-form-item
                        :label="i.label + '：'">
                        <p>{{ i.value }}</p>
                      </el-form-item>
                    </el-col>
                  </el-form>
                </template>
              </el-table-column>
            </jm-tableList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jmTableList from '@/components/data/tableList';

export default {
  components: { jmTableList },
  data() {
    return {
      refresh: false,
      searchData: {
        edit_key: '-1',
        id: 0,
      },
      options: {},
      operation: false
    };
  },
  methods: {
    fetchOption() {
      this.$http
        ._get({
          url: '/index/log/actionSearch'
        })
        .then(({ data }) => {
          this.options = data.type_list;
          this.operation = true;
        });
    },
    fetchData() {
      this.refresh = true;
    },
    setRowClass({ row }) {
      return (row.info && row.info.length) ? '' : 'expand';
    }
  },
  created() {
    this.searchData.edit_key = this.$route.params.key || '-1';
    this.searchData.id = this.$route.params.id || 0;
    this.fetchOption();
  }
};
</script>

<style>
  .log .behavior .operation {
    position: relative;
    margin-bottom: 15px;
  }

  .log .behavior .el-table__expanded-cell {
    padding: 6px 0 6px 48px;
  }

  .log .behavior .el-form-item__content {
    line-height: 36px;
  }

  .log .behavior .behavior-expand {
    font-size: 0;
  }

  .log .behavior .behavior-expand label {
    padding-right: 0;
    color: #99a9bf;
    text-align: right;
  }

  .log .behavior .behavior-expand p {
    padding-top: 6px;
    line-height: 24px;
  }

  .expand .el-table__expand-column .cell {
    display: none;
  }

  .log .behavior .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }
</style>
